import { render, staticRenderFns } from "./VSAvatarGroup.vue?vue&type=template&id=c4ef0154"
import script from "./VSAvatarGroup.vue?vue&type=script&lang=js"
export * from "./VSAvatarGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports